export default [
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/sft/Contact.vue'),
    },
  ]